export default "__VITE_ASSET__DxMN9Tha__"